module.exports = __webpack_public_path__ + "media/images/writer/reservation/logo-2d19145b916465ccbcf57824e5edca59.svg";